import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center p-8">
      <p className="mb-2 text-sm font-mono text-custel-text-tertiary">404</p>
      <h1 className="mb-2 text-3xl font-semibold">Sayfa bulunamadı</h1>
      <p className="mb-6 text-custel-text-secondary">Aradığınız sayfa mevcut değil.</p>
      <Link to="/" className="btn-primary">
        Anasayfaya dön
      </Link>
    </main>
  );
}
